import * as React from 'react';

import { useSelector } from 'react-redux';

import { InviteStudentDrawer } from '~teacher/components/ActivityResult/modals/InviteStudentDrawer';
import { selectCurrentRoomId } from '~teacher/slices/teacher/teacherSelector';

import { SpaceRaceCountdown } from './SpaceRaceCountdown';
import { SpaceRaceHeader } from './SpaceRaceHeader';
import { TeamRocket } from './TeamRocket';

export default function SpaceRaceView({
  countdownColor,
  showCountdown,
  countdownTime,
  countdownText,
  showCountdownFinish,
  finishClicked,
  stopCountdownClicked,
  minHeight,
  context,
}: {
  countdownText: string;
  countdownTime: string;
  showCountdown: boolean;
  showCountdownFinish: boolean;
  minHeight: number;
  finishClicked: () => void;
  stopCountdownClicked: () => void;
  countdownColor: string;
  context: { teams: any[]; iconType: string };
}) {
  const { teams, iconType } = context;
  const roomId = useSelector(selectCurrentRoomId);

  return (
    <div>
      {showCountdown ? (
        <SpaceRaceCountdown
          countdownColor={countdownColor}
          countdownTime={countdownTime}
          countdownText={countdownText}
          showCountdownFinish={showCountdownFinish}
          finishClicked={finishClicked}
          stopCountdownClicked={stopCountdownClicked}
        />
      ) : null}
      <div
        className="race-module-background"
        style={{ minHeight: minHeight + 'px' }}
      />
      {!showCountdown ? (
        <SpaceRaceHeader finishClicked={finishClicked} />
      ) : (
        <div style={{ height: '62px' }} />
      )}
      <div id={showCountdown ? 'race-module-with-countdown' : 'race-module'}>
        {teams.map((team, index) => (
          <TeamRocket
            key={index}
            team={team}
            teamCount={teams.length}
            iconType={iconType}
          />
        ))}
      </div>
      <InviteStudentDrawer roomId={roomId} />
    </div>
  );
}
